import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">最新动态</h2>
          <p className="text-foreground-600 text-sm">站内资源更新与平台动态速览</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-200"></div>

          <div className="space-y-6">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-14">
                <div className="absolute left-2.5 md:left-4.5 top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="p-4 rounded-xl bg-background-100 border border-background-200/60">
                  <span className="text-xs font-medium text-primary-500 mb-1 block">{item.date}</span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}